module.exports = __webpack_public_path__ + "img/video-placeholder-1-thumb.c0aca060.jpg";